import { render, staticRenderFns } from "./comments-add-form.vue?vue&type=template&id=1fd5e4de"
import script from "./comments-add-form.vue?vue&type=script&lang=js"
export * from "./comments-add-form.vue?vue&type=script&lang=js"
import style0 from "./comments-add-form.vue?vue&type=style&index=0&id=1fd5e4de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports